import { baseUrl } from '../../network'

export const averagePurchaseAmount = (companyId: number) => baseUrl + `/api/company/${companyId}/providers/stats/average_amount`
export const purchasePriceDifference = (companyId: number) => baseUrl + `/api/company/${companyId}/providers/stats/price_differenece`
export const procureToReceiveTime = (companyId: number) => baseUrl + `/api/company/${companyId}/providers/stats/procure_to_receive_time`
export const totalROIPurchases = (companyId: number) => baseUrl + `/api/company/${companyId}/providers/stats/purchase_roi`

export const topProvidersByAmount = (companyId: number) => baseUrl + `/api/company/${companyId}/providers/stats/top_providers_amount`